import React, { useCallback, useEffect, useState } from 'react';

import { Input } from '@chakra-ui/react';

import { Search } from 'assets/assetsV1/iconComponents';

import { isMobileView } from 'constants/isMobileView';

import { ChakraStyleInput } from 'uiToolkitV1/InputV2/ChakraStyleInput';

export const QuickSearch = ({
  gridRef,
  selectedCohort,
  maxWidth = '360px',
  placeholder = 'Search across title, owner, progress etc.',
  isV2 = false,
}) => {
  const [searchText, setSearchText] = useState(null);

  const handleTextChange = useCallback((e) => {
    const updatedText = e.target.value;
    setSearchText(updatedText);
  }, []);

  /*
    on searchText change set quick filter if
    - searchText is not null (on first run of effect) and
    - grid is initialized
    */
  useEffect(() => {
    if (searchText !== null && gridRef?.current?.api) {
      gridRef?.current?.api?.setGridOption('quickFilterText', searchText);
    }
  }, [gridRef, searchText]);

  /* On cohort change reset quick search text to empty string */
  useEffect(() => {
    setSearchText('');
  }, [selectedCohort]);

  if (isV2) {
    return (
      <ChakraStyleInput
        placeholder={isMobileView() ? 'Search' : placeholder}
        border="none"
        backgroundColor="#F5F7F9"
        leftComponent={<Search />}
        sx={{ maxWidth }}
        value={searchText}
        onChange={handleTextChange}
      />
    );
  }

  return (
    <Input
      placeholder={isMobileView() ? 'Search' : 'Search across title, owner, progress etc.'}
      sx={{ maxWidth: '360px' }}
      value={searchText}
      onChange={handleTextChange}
    />
  );
};
